export default __webpack_public_path__ + "static/media/Icon_2.6feefdeb.png";